export enum ComorbiditiesNames {
  AutoImmuneDisease = 'Auto immune disease',
  UncontrolledDiabetes = 'Uncontrolled diabetes',
  ActiveInfection = 'Active infection',
  LowEjectionFraction = 'Low ejection fraction',
  Hepatitis = 'Hepatitis',
  HighQT = 'High QT',
  BrainMetastasis = 'Brain Metastasis',
  HIV = 'HIV',
  DVTPE = 'DVT/PE',
}
